<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<div><h4 class="pull-left">
				{{$t('sidebar.warehouse-management.add')}}
			</h4></div>

			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
				class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<div class="row" style="margin-top: 16px">
				<div class="col-6">
					<span style="font-weight: bold">{{$t('incomes.name')}}</span>
					<h5>{{document.regNumber}}</h5>

				</div>
				<div class="col-6">
					<span style="font-weight: bold">{{$t('incomes.date')}}</span>
					<h5>{{document.regDate}}</h5>
				</div>
			</div>
			<hr>

			<!--<form>-->
			<!--<b-form-group-->
			<!--breakpoint="lg"-->
			<!--label-cols="4"-->
			<!--label-cols-lg="2"-->
			<!--label-size="sm"-->
			<!--class=""-->
			<!--&gt;-->
			<!--<template slot="label">-->
			<!--Номер дополнительного расхода<span class="text-danger"> * </span>-->
			<!--</template>-->

			<!--<b-form-input size="sm" id="costNumber"-->
			<!--v-model="formItems.costNumber"-->
			<!--autocomplete="off"-->
			<!--name="costNumber"-->
			<!--placeholder="Номер дополнительного расхода"></b-form-input>-->
			<!--</b-form-group>-->

			<!--<b-form-group-->
			<!--breakpoint="lg"-->
			<!--label-cols="4"-->
			<!--label-cols-lg="2"-->
			<!--:label="$t('goods.create.short-name')"-->
			<!--label-size="sm"-->
			<!--class=""-->
			<!--&gt;-->
			<!--<template slot="label">-->
			<!--Дата дополнительнителного расхода <span class="text-danger"> * </span>-->
			<!--</template>-->
			<!--<b-input-group size="sm">-->
			<!--<masked-input size="sm" id="costDate"-->
			<!--v-model="formItems.costDate"-->
			<!--name="costDate"-->
			<!--mask="11-11-1111"-->
			<!--class=" form-control form-control-sm "-->
			<!--placeholder="Дата дополнительнителного расхода"></masked-input>-->
			<!--<b-input-group-addon>-->
			<!--<b-button size="sm" disabled>-->
			<!--<i class="fa fa-calendar"></i>-->
			<!--</b-button>-->
			<!--</b-input-group-addon>-->
			<!--</b-input-group>-->
			<!--</b-form-group>-->

			<!--<b-form-group-->
			<!--breakpoint="lg"-->
			<!--label-cols="4"-->
			<!--label-cols-lg="2"-->
			<!--label-size="sm"-->
			<!--class=""-->
			<!--&gt;-->
			<!--<template slot="label">-->
			<!--{{ $t('incomes.create.reason') }} <span class="text-danger"> * </span>-->
			<!--</template>-->

			<!--<b-form-input size="sm" id="reason"-->
			<!--v-model="formItems.reason"-->
			<!--autocomplete="off"-->
			<!--name="reason"-->
			<!--:placeholder="$t('incomes.create.reason')">-->
			<!--</b-form-input>-->
			<!--</b-form-group>-->


			<b-row>
				<b-col cols="4">
					<b-form-select
						v-model="cost.categoryId"
					>
						<option v-for="(selectOption, indexOpt) in brands"
								:key="indexOpt"
								:value="selectOption.id"
						>
							{{ selectOption.name }}
						</option>
						<template slot="first">
							<option disabled :value="null">-- {{$t('sidebar.warehouse-management.extra-cost')}} --</option>
						</template>
					</b-form-select>

				</b-col>
				<!--<b-col cols="6">-->
				<!--<b-form-group-->
				<!--breakpoint="lg"-->
				<!--label-size="sm"-->
				<!--label-cols="4"-->
				<!--label-for="refName"-->
				<!--class="required"-->
				<!--&gt;-->
				<!--<b-input-group size="sm">-->
				<!--<b-form-input :required="true"-->
				<!--size="sm"-->
				<!--id="inUsd"-->
				<!--autocomplete="off"-->
				<!--@focus="$event.target.select()"-->
				<!--type="number"-->
				<!--v-model.number="formItems.costUsd"-->
				<!--class="ml-1"-->
				<!--:placeholder="$t('incomes.create.price')"/>-->
				<!--<b-input-group-addon>-->
				<!--<b-button disabled size="sm">USD</b-button>-->
				<!--</b-input-group-addon>-->
				<!--</b-input-group>-->
				<!--</b-form-group>-->
				<!--</b-col>-->
				<div v-if="isVat">
					<b-form-checkbox
						id="checkbox-1"
						v-model="vatSelected"
						name="checkbox-1"
						value="true"
						unchecked-value="false"
					>
						С ндс
					</b-form-checkbox>

					<p>Ндс: <strong>20</strong></p>
				</div>
				<b-col>
					<b-form-group
						breakpoint="lg"
						label-size="sm"
						label-cols="4"
						label-for="refName"
						class="required"
					>
						<b-input-group  autocomplete="off" size="sm">
							<b-form-input :required="true"
										  size="sm"
										  id="inUzs"
										  autocomplete="off"
										  @focus="$event.target.select()"
										  type="number"
										  v-model.number="cost.currencyCost"
										  class="ml-1"
										  :placeholder="$t('incomes.create.price')"/>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ currencyId ? currencyId : depCurrencyCode }}</b-button>
								<!-- <b-form-select v-model="currencyId" :options="refCurrencies" size="sm" value-field="code" text-field="name" @input="selectedCurrency">
									<template slot="first">
										<option :value="null" disabled>{{ $t('department.money-type-department') }}</option>
									</template>
								</b-form-select> -->
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>
				</b-col>
			</b-row>

			<b-row>
				<b-col cols="12">
<!--					<b-form-group label-cols="4" label-cols-lg="2" label-size="sm" :label="$t('department.money-type')+':'" label-for="incomeCurrency">-->
<!--						<b-form-select v-model="currencyId" :options="refCurrencies" size="sm" :text-field="'currencyName'" @input="selectedCurrency">-->
<!--							<template slot="first">-->
<!--								<option :value="null" disabled>{{ $t('department.money-type-department') }}</option>-->
<!--							</template>-->
<!--						</b-form-select>-->
<!--					</b-form-group>-->
				</b-col>
			</b-row>

			<b-row class="mb-3" v-if="currencyId && currencyId != depCurrencyCode">
				<b-col cols="5">
					<b-form-group breakpoint="lg" label-size="sm" label-cols="5" :label="$t('kochirish.currencyRate')" label-class="ml-1" class="required">
						<b-input-group size="sm" class="p-0" v-if="rightOrLeft">
							<b-form-input v-model="exchangeCurrency" disabled type="number"/>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ currencyId }}</b-button>
							</b-input-group-addon>
						</b-input-group>
						<b-input-group size="sm" class="p-0" v-else>
							<b-form-input disabled v-model="exchangedCurrency" type="number"/>
							<b-input-group-addon>
								<b-button disabled size="sm">{{ depCurrencyCode }}</b-button>
							</b-input-group-addon>
						</b-input-group>
					</b-form-group>
				</b-col>
				<b-col cols="1" align="center">
					<b-button variant="primary" @click="exchange">
						<i class="fa fa-exchange"></i>
					</b-button>
				</b-col>
				<b-col align="left">
					<b-input-group size="sm" class="p-0" v-if="rightOrLeft">
						<b-form-input v-model="exchangedCurrency" type="number"/>
						<b-input-group-addon>
							<b-button disabled size="sm">{{ depCurrencyCode }}</b-button>
						</b-input-group-addon>
					</b-input-group>
					<b-input-group size="sm" class="p-0" v-else>
						<b-form-input v-model="exchangeCurrency" type="number"/>
						<b-input-group-addon>
							<b-button disabled size="sm">{{ currencyId }}</b-button>
						</b-input-group-addon>
					</b-input-group>
				</b-col>
				<b-col></b-col>
			</b-row>

			<b-form-group
				breakpoint="lg"
				label-cols="4"
				label-cols-lg="2"
				label-size="sm"
				class=""
			>
				<!--<template slot="label">-->
				<!--{{ $t('incomes.create.comment') }}-->
				<!--</template>-->

				<b-textarea size="sm" id="comment"
							v-model="cost.comment"
							name="comment"
							:placeholder="$t('incomes.create.comment')">
				</b-textarea>
			</b-form-group>
			<div style="display: flex;justify-content: flex-end;">
				<b-button @click="addItemExtraCost" variant="success">
					{{$t('sidebar.warehouse-management.add')}}
				</b-button>
			</div>
			<!--<span>{{this.tempArray}}</span>-->
			<table v-if="tempArray.length>0" hover="hover" striped="striped" class="table b-table table-bordered table-striped table-hover mt-3">
				<thead>
					<tr>
						<th class="text-center" style="width: 2%; word-break: break-all;">Id</th>
						<th class="text-center" style="width: 10%;">{{$t('sidebar.warehouse-management.extra-cost')}}</th>
						<th class="text-center" style="width: 10%">Цена</th>
						<th class="text-center" style="width: 10%">Цена ({{ depCurrencyCode }})</th>
						<th class="text-center" style="width: 20%; word-break: break-all;">Comment</th>
						<th class="table_actions">{{ $t('goods.actions') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,index) in tempArray" :key="index">
						<!--<td>{{name}}</td>-->
						<td class="text-center">{{index+1}}</td>
						<td>{{setReason(item.categoryId)}}</td>
						<td  class="text-center">{{item.currencyCost| currency({symbol: item.currencyName, symbolPosition: 'back',fractionCount:3})}}</td>
						<td  class="text-center">{{item.cost| currency({symbol: item.depCurrencyName, symbolPosition: 'back',fractionCount:3})}}</td>
						<td>{{item.comment}}</td>
						<td class="table_actions">
							<b-link @click="deleteFromTempArray(item, index)">
								<i class="fa fa-trash"></i>
							</b-link>
						</td>
					</tr>
				</tbody>
			</table>
			<!--<div v-if="tempArray.length>0" style="justify-content: flex-end; display: flex;">-->
				<!--<b-form-group>-->
					<!--<span>Выберите тип распределение:</span>-->

					<!--<b-form-radio-group-->
						<!--id="btnradios1"-->
						<!--buttons-->
						<!--style="margin-left: 10px;"-->
						<!--v-model="priceType"-->
						<!--button-variant="outline-primary"-->
						<!--:options	="[-->
			<!--{-->
              <!--text: 'ШТ',-->
              <!--value: 'RETIAL_SALE'-->
            <!--},-->
            <!--{-->
              <!--text: 'KG',-->
              <!--value: 'KG'-->
            <!--}]"-->
						<!--name="radiosBtnDefault"-->
					<!--/>-->
				<!--</b-form-group>-->
			<!--</div>-->
			<!--</form>-->
			<div class="modal-actions">
				<b-row class="align-items-center">
					<b-col cols="8" class="mb-3 mb-xl-0">
						<b-row>
							<b-col cols="4">
								<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
									$t('cancel') }}
								</b-button>
							</b-col>
							<b-col cols="3">
								<b-button block type="button" size="sm" @click="SUSPENDED" variant="btn btn-warning">
									{{ $t('save') }}
								</b-button>
							</b-col>
							<b-col cols="5">
								<b-button class="btn btn-success" block type="button" size="sm" @click="create" variant="primary">
									{{ $t('warehouse.document.saveAndFinish') }}
								</b-button>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</div>
	</div>
</template>

<script>
    import {mapState} from 'vuex'
    import MaskedInput from 'vue-masked-input'

    import ExtraCost from "../../../../services/extraCost.service";
    import CurrencyService from "../../../../services/currency.service";
    import ReferencesService from "../../../../services/references.sevice";
    import {Incomes} from "../mixins/Incomes";

    const initial = {
        categoryId: null,
        cost: null,
        comment: null,

    };
    export default {
        name: 'CostForm',
        mixins: [Incomes],
        props: {
            document: {
                type: Object,
                default: null,
            }
        },

        data() {
            return {
                brands: [],
				rightOrLeft: true,
				exchangeCurrency: 1,
				exchangedCurrency: null,
				refCurrencies: [],
				currencyId: null,
				exchangeCurrencyName: '',
                depCurrencyCode: '',
                depCurrencyId: null,
                cost: {
                    id: null,
                    comment: null,
                    cost: null,
					currencyCost: null,
                    categoryId: null,
                    documentId: null,
                    categoryName: null,
                    categoryCode: null,
                    currencyId: null,
                    currencyName: null,
                    currencyCode: null,
					depCurrencyCost: null,
					depCurrencyCode: null,
					depCurrencyName: null,
					depCurrencyId: null
                },
				isVat: false,
				vatSelected: false,
                priceType: 'RETIAL_SALE',
                currencyRate: -1,
                tempArray: [],
            }
        },
        methods: {
			selectedCurrency() {
				this.rightOrLeft = false
				this.exchangeCurrency = null
				this.exchangedCurrency = 1
				let toId = null
				this.refCurrencies.forEach(t => {
					if (t.code == this.currencyId) {
						toId = t.id
					}
				})
				CurrencyService.get(this.depCurrencyId, toId, this.document.regDate).then(res => {
					this.exchangeCurrency = res.data
				})
			},
			exchange() {
				this.rightOrLeft = !this.rightOrLeft
				let toId = null
				this.refCurrencies.forEach(t => {
					if (t.code == this.currencyId) {
						toId = t.id
					}
				})
				if (!this.rightOrLeft) {
					this.exchangeCurrency = null
					this.exchangedCurrency = 1
					CurrencyService.get(this.depCurrencyId, toId, this.document.regDate).then(res => {
						this.exchangeCurrency = res.data
					})
				} else {
					this.exchangeCurrency = 1
					this.exchangedCurrency = null
					CurrencyService.get(toId, this.depCurrencyId, this.document.regDate).then(res => {
						this.exchangedCurrency = res.data
					})
				}
			},
            deleteFromTempArray(item, index) {
                this.tempArray.splice(index, 1);
            },
            setReason(categoryId) {
                let temp = [];
                for (let i = 0; i < this.brands.length; i++) {
                    if (this.brands[i].id === categoryId) {

                        temp = this.brands[i].name;
                    }
                }
                return temp
            },
            addItemExtraCost() {
				if (this.currencyId) {
					this.refCurrencies.forEach(t => {
						if (t.name == this.currencyId) {
							this.cost.currencyName = t.name
							this.cost.currencyCode = t.code
							this.cost.currencyId = t.id
						}
					})
					if (this.rightOrLeft) {
						this.cost.cost = this.cost.currencyCost * this.exchangedCurrency
						this.cost.fromCurrencyRate = this.exchangeCurrency
						this.cost.toCurrencyRate = this.exchangedCurrency
						this.cost.fromCurrencyName = this.currencyId
						this.cost.toCurrencyName = this.depCurrencyCode
					} else {
						this.cost.cost = this.cost.currencyCost / this.exchangeCurrency
						this.cost.fromCurrencyRate = this.exchangedCurrency
						this.cost.toCurrencyRate = this.exchangeCurrency
						this.cost.fromCurrencyName = this.depCurrencyCode
						this.cost.toCurrencyName = this.currencyId
					}
				} else {
					this.cost.currencyId = this.depCurrencyId
					this.cost.currencyCode = this.depCurrencyCode
					this.cost.currencyName = this.depCurrencyCode
					this.cost.cost = this.cost.currencyCost
				}
				this.cost.depCurrencyCode = this.depCurrencyCode
				this.cost.depCurrencyName = this.depCurrencyCode
				this.cost.depCurrencyId = this.depCurrencyId
                let obj = Object.assign({}, this.cost);
                if (obj.categoryId !== null && obj.currencyCost !== null) {
                    this.tempArray.push(obj);
                    this.currencyId = null
					this.exchangeCurrency = 1
					this.exchangedCurrency = null
					this.rightOrLeft = true
                    Object.assign(this.cost, initial);
					this.cost.currencyCost = null
				} else {
                    this.$vs.notify({
                        text: 'Выберите тип распределение',
                        color: 'warning',
                        icon: 'close',
                        position: 'top-right'
                    });
                }
            },
            loadBrands() {
                ReferencesService.getReferenceChildren(`ExtraCosts`).then(response => {
                    this.brands = response.data;
                })
            },
			SUSPENDED(){
				let header = {}
				header.docId = this.document.id;
				header.method = this.priceType;
				if (this.priceType !== '') {
					ExtraCost.createOrUpdateSuspended(this.tempArray, header).then(response => {
						this.$emit('close');
					})
				} else {
					this.$vs.notify({
						text: 'Выберите тип распределение',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
            cancel() {
                this.$emit('close');
            },
            create() {
                let header = {}
                header.docId = this.document.id;
                header.method = this.priceType;
                if (this.priceType !== '') {
                    ExtraCost.createOrUpdate(this.tempArray, header).then(response => {
                        this.$emit('close');
                    })
                } else {
                    this.$vs.notify({
                        text: 'Выберите тип распределение',
                        color: 'warning',
                        icon: 'close',
                        position: 'top-right'
                    });
                }
            }
        },

        computed: {
            ...mapState(['userDepCurrencyName']),
            formItems() {
                return this.cost;
            },
			depCurrency() {
            	let tmp
            	this.refCurrencies.forEach(t => {
            		if (t.currencyCode == this.depCurrencyCode) {
            			tmp = t
					}
				})
				return tmp
			}
        },

        components: {
            MaskedInput
        },

        created() {
            this.loadBrands();
            ExtraCost.loadByDocument(this.document.id).then(response => {
                if (response.length > 0) {
                    this.tempArray = response;
                }
            });
            const department = (this.document.action === "KIRIM") ? this.document.toDepartmentId : this.document.fromDepartmentId;
            CurrencyService.getListCurrency().then(response => {
                this.refCurrencies = response.data;
            });
            this.depCurrencyCode = localStorage.getItem("depCurrencyName");
            this.depCurrencyId = localStorage.getItem("depCurrencyId");
        },

        watch: {
            'cost.costUsd': {
                handler(newValue) {
                    if (this.currencyRate !== -1) {
                        this.cost.cost = newValue * this.currencyRate;
                    }
                }
            },
            'cost.cost': {
                handler(newValue) {
                    if (this.currencyRate !== -1) {
                        this.cost.costUsd = newValue / this.currencyRate;
                    }
                }
            },
			'cost.categoryId': {
				handler(newValue) {
					let obj = this.brands.filter(item => {
						return item.id === newValue && item.code === "VAT"
					});
					if(obj.length > 0){
						this.isVat = true;
					}else{
						this.isVat = false;
					}
				}
			},

        }
    }
</script>

<style scoped lang="scss">
	.table_actions {
		width: 6%;
		text-align: center;
		div {
			display: none;
		}

		a {
			margin-right: 12%;

			i {
				font-size: 1.3em;
				color: #53575B
			}
		}
	}
</style>
